import client from "./httpClient";
import * as apiConstants from "../constants/Api";
import { getErrorHandler, normalizeError } from "./apiErrorHandling";

const errorHandler = getErrorHandler({});

const handleProfileServiceError = async error => {
  const normalized = await normalizeError(error);
  errorHandler(normalized);
  // we can't stop execution even if error was handled so we rethrow
  throw normalized;
};

const baseUrl = `${apiConstants.SERVER_URL}/profile-service`;

export const fetchMe = async () => {
  const user = await client
    .get(`${baseUrl}/me`)
    .json()
    .catch(handleProfileServiceError);

  if (user.status === apiConstants.STATUS_EXPIRED_PASSWORD) {
    window.location.replace(apiConstants.PASSWORD_CHANGE_URL);
  }

  return user;
};
